/* Doctor Trigger — Sleep homepage core.
   Progressive: the page reads correctly with none of this. Order of work: reveal text first, sky + clock next,
   then (idle, capable devices only) the three.js body scan. Section modules register with DTS.register(). */
(function () {
  'use strict';
  var main = document.querySelector('.dt-sleep-main');
  if (!main || main.__dts) return;
  main.__dts = true;

  var mqReduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mqFine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var DTS = (window.DTS = window.DTS || {});
  DTS.reduce = mqReduce.matches;
  DTS.fine = mqFine.matches;
  DTS.modules = DTS.modules || [];
  DTS.register = function (name, fn) { DTS.modules.push({ name: name, fn: fn }); if (DTS.booted) run({ name: name, fn: fn }); };
  function run(m) { try { m.fn(main, DTS); } catch (e) { if (window.console) console.warn('[dts] ' + m.name, e); } }
  DTS.clamp = function (v, a, b) { return v < a ? a : v > b ? b : v; };
  DTS.lerp = function (a, b, t) { return a + (b - a) * t; };
  DTS.track = function (name, detail) {
    try { document.dispatchEvent(new CustomEvent('dts:' + name, { detail: detail || {} })); (window.dataLayer = window.dataLayer || []).push({ event: 'dts_' + name, dts: detail || {} }); } catch (e) {}
  };

  /* ---------- reveals ---------- */
  function reveals() {
    var els = [].slice.call(main.querySelectorAll('[data-dts-reveal], .dts-rise'));
    if (!('IntersectionObserver' in window) || DTS.reduce) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
    DTS.observeReveal = function (el) { io.observe(el); };
  }

  /* ---------- sky + clock: one scroll listener, one rAF ---------- */
  var SKY = {
    dusk: ['#161a45', '#4b4a8c', '#d99aa0', 0.35],
    night: ['#070b1d', '#0b1026', '#141c42', 1],
    deep: ['#03040a', '#05070f', '#0a0e1f', 0.75],
    rem: ['#0a0820', '#171034', '#2a1a4a', 0.9],
    dawn: ['#a9c0ea', '#f6d3c0', '#fff1e0', 0]
  };
  function hex(h) { return [parseInt(h.substr(1, 2), 16), parseInt(h.substr(3, 2), 16), parseInt(h.substr(5, 2), 16)]; }
  Object.keys(SKY).forEach(function (k) { SKY[k] = { a: hex(SKY[k][0]), b: hex(SKY[k][1]), c: hex(SKY[k][2]), s: SKY[k][3] }; });
  function mix(c1, c2, t) { return 'rgb(' + Math.round(c1[0] + (c2[0] - c1[0]) * t) + ',' + Math.round(c1[1] + (c2[1] - c1[1]) * t) + ',' + Math.round(c1[2] + (c2[2] - c1[2]) * t) + ')'; }
  function ease(t) { return t * t * (3 - 2 * t); }

  function sky() {
    var bands = [], clock = main.querySelector('.dts-clock'), tEl = clock && clock.querySelector('.dts-clock__t'), pEl = clock && clock.querySelector('.dts-clock__p');
    var stage = main.querySelector('[data-dts-stage]');
    main.classList.add('dts-skyon');
    function measure() {
      bands = [].slice.call(main.querySelectorAll('[data-sky]')).map(function (el) {
        var r = el.getBoundingClientRect(), top = r.top + window.pageYOffset;
        var c = (el.getAttribute('data-clock') || '').split(':');
        return { el: el, top: top, bottom: top + r.height, sky: SKY[el.getAttribute('data-sky')] || SKY.night, name: el.getAttribute('data-sky'), min: c.length === 2 ? (+c[0]) * 60 + (+c[1]) : null, phase: el.getAttribute('data-phase') || '' };
      }).sort(function (x, y) { return x.top - y.top; });
      // clock minutes must run forward through midnight
      var add = 0, prev = -1;
      bands.forEach(function (b) { if (b.min == null) return; if (b.min + add < prev) add += 1440; b.min += add; prev = b.min; });
    }
    var ticking = false, lastTxt = '', lastPhase = '';
    function frame() {
      ticking = false;
      if (!bands.length) return;
      var vh = window.innerHeight, y = window.pageYOffset, mid = y + vh * 0.5, R = vh * 0.42;
      var i = 0;
      for (var k = 0; k < bands.length; k++) { if (mid >= bands[k].top) i = k; }
      var cur = bands[i], nxt = bands[i + 1], prv = bands[i - 1], from = cur.sky, to = cur.sky, t = 0;
      if (nxt && nxt.top - mid < R) { to = nxt.sky; t = ease(0.5 * (1 - (nxt.top - mid) / R)); }
      else if (prv && mid - cur.top < R) { from = prv.sky; to = cur.sky; t = ease(0.5 + 0.5 * ((mid - cur.top) / R)); }
      var st = main.style;
      st.setProperty('--dts-sky-a', mix(from.a, to.a, t));
      st.setProperty('--dts-sky-b', mix(from.b, to.b, t));
      st.setProperty('--dts-sky-c', mix(from.c, to.c, t));
      st.setProperty('--dts-stars', (from.s + (to.s - from.s) * t).toFixed(3));
      DTS.nightness = from.s + (to.s - from.s) * t;
      // stage progress (hero -> router), shared with CSS and the 3D scene
      if (stage) {
        var sr = stage.getBoundingClientRect(), sp = DTS.clamp(-sr.top / Math.max(1, vh * 0.9), 0, 1);
        DTS.stageP = sp; st.setProperty('--dts-stage-p', sp.toFixed(4));
        DTS.stageOn = sr.bottom > 0 && sr.top < vh;
      }
      // clock
      if (clock) {
        var a = cur, b = nxt, m = a.min;
        if (a.min != null && b && b.min != null) m = a.min + (b.min - a.min) * DTS.clamp((mid - a.top) / Math.max(1, b.top - a.top), 0, 1);
        else if (a.min != null) m = a.min + 110 * DTS.clamp((mid - a.top) / Math.max(1, a.bottom - a.top), 0, 1);
        if (m != null) {
          var mm = Math.round(m) % 1440, h = Math.floor(mm / 60), mi = mm % 60, txt = ((h % 12) || 12) + ':' + (mi < 10 ? '0' : '') + mi + (h < 12 ? ' AM' : ' PM');
          if (txt !== lastTxt) { tEl.textContent = txt; lastTxt = txt; }
          clock.style.setProperty('--phase', (DTS.clamp((m - 1300) / 620, 0, 1)).toFixed(3));
        }
        if (cur.phase !== lastPhase) { pEl.textContent = cur.phase; lastPhase = cur.phase; }
        clock.classList.toggle('is-day', cur.name === 'dawn' && t < 0.5 || (to === SKY.dawn && t >= 0.5));
        var last = bands[bands.length - 1];
        var on = y > vh * 0.35 && y + vh < last.bottom + 40;
        clock.classList.toggle('is-on', on);
        if (on) clockBusy();
      }
    }
    /* the clock steps aside while a line of text scrolls under it: hides at once, comes back after the band has been clear for a moment */
    var TEXTY = /^(P|H[1-6]|LI|SPAN|A|BUTTON|EM|STRONG|SUMMARY|DD|DT|BLOCKQUOTE|FIGCAPTION|LABEL|SMALL|S|Q|CITE|TIME|CODE|ABBR)$/, busyT = 0, wasBusy = false;
    function clockBusy() {
      if (!document.elementFromPoint) return;
      var r = clock.getBoundingClientRect(); if (!r.width) return;
      var cy = r.top + r.height / 2, hit = false, xs = [r.left + 6, r.left + r.width / 2, r.right - 6];
      for (var i = 0; i < xs.length && !hit; i++) { var el = document.elementFromPoint(xs[i], cy); hit = !!(el && TEXTY.test(el.tagName) && !clock.contains(el)); }
      if (hit) { wasBusy = true; clearTimeout(busyT); busyT = 0; clock.classList.add('is-busy'); }
      else if (wasBusy && !busyT) busyT = setTimeout(function () { busyT = 0; wasBusy = false; clock.classList.remove('is-busy'); }, 500);
    }
    function req() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    function top() { var h = document.querySelector('.shopify-section-group-header-group.sticky-top, .sticky-top'); var b = h ? h.getBoundingClientRect().bottom : 0; main.style.setProperty('--dts-top', Math.max(0, Math.round(b)) + 'px'); }
    top(); window.addEventListener('resize', top); window.addEventListener('load', top);
    measure(); frame();
    window.addEventListener('scroll', req, { passive: true });
    window.addEventListener('resize', function () { measure(); req(); });
    window.addEventListener('load', function () { measure(); req(); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { measure(); req(); });
    if ('ResizeObserver' in window) new ResizeObserver(function () { measure(); req(); }).observe(main);
    DTS.remeasure = function () { measure(); req(); };
  }

  /* ---------- stars: a tiny 2D canvas in the fixed sky ---------- */
  function stars() {
    var cv = main.querySelector('.dts-sky__stars'); if (!cv || !cv.getContext) return;
    var ctx = cv.getContext('2d'), list = [], w = 0, h = 0, dpr = Math.min(window.devicePixelRatio || 1, 1.5), raf = 0, t0 = performance.now();
    function size() {
      w = cv.clientWidth; h = cv.clientHeight; cv.width = w * dpr; cv.height = h * dpr;
      var n = Math.round(Math.min(190, (w * h) / 7000)); list = [];
      for (var i = 0; i < n; i++) { var r = Math.random(); list.push({ x: Math.random() * w, y: Math.pow(Math.random(), 1.35) * h, r: (r < 0.92 ? 0.5 + Math.random() * 0.7 : 1.1 + Math.random() * 0.8), p: Math.random() * 6.28, s: 0.4 + Math.random() * 1.1 }); }
      draw(performance.now());
    }
    function draw(now) {
      var t = (now - t0) / 1000; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx.clearRect(0, 0, w, h); ctx.fillStyle = '#eef2ff';
      for (var i = 0; i < list.length; i++) { var s = list[i]; ctx.globalAlpha = DTS.reduce ? 0.7 : 0.35 + 0.65 * (0.5 + 0.5 * Math.sin(t * s.s + s.p)); ctx.beginPath(); ctx.arc(s.x, s.y, s.r, 0, 6.2832); ctx.fill(); }
    }
    var last = 0;
    function loop(now) { raf = requestAnimationFrame(loop); if ((DTS.nightness || 0) < 0.04 || now - last < 66) return; last = now; draw(now); }
    size(); window.addEventListener('resize', size);
    if (!DTS.reduce) raf = requestAnimationFrame(loop);
  }

  /* ---------- magnetic buttons (desktop pointer only) ---------- */
  function magnets() {
    if (!DTS.fine || DTS.reduce || !window.gsap) return;
    [].forEach.call(main.querySelectorAll('[data-dts-magnet]'), function (el) {
      var qx = gsap.quickTo(el, 'x', { duration: 0.5, ease: 'power3' }), qy = gsap.quickTo(el, 'y', { duration: 0.5, ease: 'power3' });
      el.addEventListener('pointermove', function (e) { var r = el.getBoundingClientRect(); qx((e.clientX - r.left - r.width / 2) * 0.22); qy((e.clientY - r.top - r.height / 2) * 0.3); });
      el.addEventListener('pointerleave', function () { qx(0); qy(0); });
    });
  }

  /* ---------- body scan router: chips + hotspots + answer card ---------- */
  function router() {
    var root = main.querySelector('[data-dts-router]'); if (!root) return;
    var chips = [].slice.call(root.querySelectorAll('.dts-chip')), spots = [].slice.call(root.querySelectorAll('.dts-spot'));
    var answer = root.querySelector('[data-dts-answer]'), panels = [].slice.call(root.querySelectorAll('.dts-answer__panel')), spotsWrap = root.querySelector('[data-dts-spots]');
    var current = null, lastChip = null;
    spots.forEach(function (s) { s.setAttribute('aria-expanded', 'false'); });
    function select(target, point, how) {
      if (current === target) target = null;
      var prev = current; current = target;
      panels.forEach(function (p) { p.classList.toggle('is-active', p.id === target); });
      chips.forEach(function (c) { var on = c.getAttribute('data-target') === target; c.setAttribute('aria-pressed', on ? 'true' : 'false'); if (on) lastChip = c; });
      spots.forEach(function (s) { var on = s.getAttribute('data-target') === target; s.classList.toggle('is-active', on); s.setAttribute('aria-expanded', on ? 'true' : 'false'); });
      answer.classList.toggle('has-active', !!target);
      root.classList.toggle('has-answer', !!target);
      main.classList.toggle('dts-has-answer', !!target);
      if (DTS.scan && DTS.scan.select) DTS.scan.select(target ? point : null);
      if (target) {
        DTS.track('router_select', { point: point, how: how });
        // bring the card on screen at every width: under the sticky header, above the fold
        var p = document.getElementById(target);
        if (p) setTimeout(function () {
          var r = p.getBoundingClientRect(), top = parseFloat(getComputedStyle(main).getPropertyValue('--dts-top')) || 0, by = 0;
          if (r.top < top + 12) by = r.top - top - 24; else if (r.bottom > window.innerHeight - 24) by = Math.min(r.bottom - window.innerHeight + (window.innerWidth < 990 ? 96 : 24), r.top - top - 24);
          if (by) window.scrollBy({ top: by, behavior: DTS.reduce ? 'auto' : 'smooth' });
        }, 60);
      } else if (prev) {
        // closing must not drop focus on <body>: hand it back to the chip for the card that just closed
        var back = chips.filter(function (c) { return c.getAttribute('data-target') === prev; })[0] || lastChip || chips[0];
        if (back && (document.activeElement === document.body || !document.activeElement || answer.contains(document.activeElement))) back.focus({ preventScroll: true });
      }
      if (DTS.remeasure) DTS.remeasure();
    }
    chips.concat(spots).forEach(function (b) { b.addEventListener('click', function () { select(b.getAttribute('data-target'), b.getAttribute('data-spot'), b.classList.contains('dts-chip') ? 'chip' : 'body'); }); });
    var close = root.querySelector('[data-dts-answer-close]'); if (close) close.addEventListener('click', function () { select(null); });
    root.addEventListener('keydown', function (e) { if (e.key === 'Escape' && current) select(null); });
    DTS.routerSpots = { wrap: spotsWrap, spots: spots };
  }

  /* ---------- three.js body scan: only for devices that can afford it, only after first paint ---------- */
  function scan() {
    var stage = main.querySelector('[data-dts-stage]'); if (!stage) return;
    var canvas = stage.querySelector('[data-dts-canvas]');
    var conn = navigator.connection || {}, lowMem = navigator.deviceMemory && navigator.deviceMemory <= 2;
    if (DTS.reduce || conn.saveData || lowMem || !webgl()) { posterSpots(); return; }
    var started = false, eager = false;
    function start() {
      if (started) return; started = true;
      var phone = window.innerWidth < 750, weak = (navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 4) || (navigator.deviceMemory && navigator.deviceMemory <= 4);
      var full = parseInt(stage.getAttribute('data-particles'), 10) || 24000, small = phone || weak;
      // phones draw at most 14k points on a canvas under 750px wide, so they get the light figure file (a quarter of the full one) rather than 42% of a download they throw away
      var opts = { stage: stage, canvas: canvas, three: stage.getAttribute('data-three'), figure: stage.getAttribute(small ? 'data-figure-lite' : 'data-figure'), figureFallback: stage.getAttribute('data-figure'),
        max: weak ? 8000 : phone ? Math.min(full, 14000) : full, small: small, DTS: DTS };
      function go(mount) {
        Promise.resolve(mount(opts)).then(function (api) { DTS.scan = api; main.classList.add('dts-scan-live'); })
          .catch(function (e) { if (window.console) console.warn('[dts] scan unavailable', e); posterSpots(); });
      }
      if (window.__dtsMount) { go(window.__dtsMount); return; }
      /* Shopify's asset pipeline rewrites a bare import() in a classic script to require(), which throws in the browser and left the
         scan dead in production while it worked locally. Handing the load to an injected module script keeps it a real dynamic
         import - the URL is only a string here, so nothing rewrites it. */
      var boot = document.createElement('script');
      boot.type = 'module';
      boot.textContent = 'import(' + JSON.stringify(stage.getAttribute('data-scan')) + ').then(function(m){window.__dtsMount=m.mount;}).catch(function(e){window.__dtsMountError=e;}).then(function(){window.dispatchEvent(new Event("dts:mount-ready"));});';
      var gaveUp = setTimeout(function () { posterSpots(); }, 9000);
      window.addEventListener('dts:mount-ready', function () {
        clearTimeout(gaveUp);
        if (window.__dtsMount) go(window.__dtsMount);
        else { if (window.console) console.warn('[dts] scan module failed', window.__dtsMountError); posterSpots(); }
      }, { once: true });
      document.head.appendChild(boot);
    }
    // never before the load event: a scroll or tap while the page is still loading only marks the visitor as eager, and load then starts at once instead of waiting for idle
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 900); };
    function nudge() { if (document.readyState === 'complete') start(); else eager = true; }
    if (document.readyState === 'complete') idle(start, { timeout: 2500 }); else window.addEventListener('load', function () { if (eager) start(); else idle(start, { timeout: 2500 }); });
    window.addEventListener('scroll', nudge, { passive: true, once: true });
    window.addEventListener('pointerdown', nudge, { passive: true, once: true });
  }
  /* a real context probe: the constructor exists on machines that refuse to create a context, and the 3D bundle must not be fetched for those */
  function webgl() {
    try { var c = document.createElement('canvas'); return !!(c.getContext('webgl2') || c.getContext('webgl') || c.getContext('experimental-webgl')); } catch (e) { return false; }
  }
  /* no WebGL: pin the hotspots to the poster image using its baked map (percent of the poster box) */
  var POSTER_MAP = { neck_shoulder: [31.5, 36.6], throat: [27.9, 46.9], hips_back: [49.1, 34.3], knees: [62.6, 44.1], feet: [75.7, 49.3] };
  function posterSpots() {
    var rs = DTS.routerSpots; if (!rs || !rs.wrap) return;
    var box = main.querySelector('.dts-router__poster'); if (!box) return;
    // the poster is only fetched on this path (the markup carries its URLs; <noscript> holds the no-JS copy)
    var img = box.querySelector('img');
    if (!img && box.getAttribute('data-src')) {
      img = document.createElement('img'); img.alt = ''; img.width = +box.getAttribute('data-w') || 1600; img.height = +box.getAttribute('data-h') || 900; img.decoding = 'async';
      if (box.getAttribute('data-srcset')) { img.srcset = box.getAttribute('data-srcset'); img.sizes = 'min(1100px, 96vw)'; }
      img.src = box.getAttribute('data-src'); box.appendChild(img);
    }
    if (!img) return;
    function place() {
      var host = rs.wrap.getBoundingClientRect(), r = img.getBoundingClientRect(); if (!r.width) return;
      // on a phone the 16:9 poster is ~350px wide, so the five 56px targets would overlap: the chips (same choices, 50px tall) are the control there
      if (window.innerWidth < 750) { rs.wrap.classList.remove('is-on'); return; }
      rs.spots.forEach(function (s) { var m = POSTER_MAP[s.getAttribute('data-spot')]; if (!m) { s.style.display = 'none'; return; } s.style.transform = 'translate3d(' + (r.left - host.left + r.width * m[0] / 100) + 'px,' + (r.top - host.top + r.height * m[1] / 100) + 'px,0)'; });
      rs.wrap.classList.add('is-on');
    }
    if (img.complete && img.naturalWidth) place(); else img.addEventListener('load', place);
    window.addEventListener('resize', place);
  }

  /* ---------- caveats live ON the number: instant popover, works on tap ---------- */
  function tips() {
    var tip = document.createElement('div'); tip.className = 'dts-tipbox'; tip.setAttribute('role', 'tooltip'); tip.id = 'dts-tipbox'; main.appendChild(tip);
    var cur = null, shownAt = 0;
    function show(el) {
      if (cur !== el) shownAt = performance.now();
      cur = el; tip.textContent = el.getAttribute('data-dts-tip'); tip.classList.add('is-on'); el.setAttribute('aria-describedby', 'dts-tipbox');
      var r = el.getBoundingClientRect(), tw = Math.min(300, window.innerWidth - 24); tip.style.maxWidth = tw + 'px';
      var b = tip.getBoundingClientRect(), x = DTS.clamp(r.left + r.width / 2 - b.width / 2, 12, window.innerWidth - b.width - 12), above = r.top - b.height - 12;
      tip.style.left = x + 'px'; tip.style.top = (above > 70 ? above : r.bottom + 12) + 'px';
    }
    function hide() { if (cur) cur.removeAttribute('aria-describedby'); cur = null; tip.classList.remove('is-on'); }
    main.addEventListener('mouseover', function (e) { var el = e.target.closest && e.target.closest('[data-dts-tip]'); if (el) show(el); else if (cur) hide(); });
    main.addEventListener('focusin', function (e) { var el = e.target.closest && e.target.closest('[data-dts-tip]'); if (el) show(el); });
    main.addEventListener('focusout', hide);
    // a tap fires mouseover (show) and then click in the same gesture: only a SECOND tap on the same number, 400ms later, closes it
    main.addEventListener('click', function (e) { var el = e.target.closest && e.target.closest('[data-dts-tip]'); if (el) { if (cur === el && !DTS.fine && performance.now() - shownAt > 400) hide(); else show(el); } else hide(); });
    // scrolling closes a hover tip, but a tip on the focused number follows it (Tab often scrolls the number into view)
    window.addEventListener('scroll', function () { if (!cur) return; if (cur === document.activeElement) show(cur); else hide(); }, { passive: true });
  }

  /* ---------- poster-first video: nothing downloads until it is nearly on screen ---------- */
  /* a video may carry a lighter WebM next to its MP4 (data-src-webm); use it only where the browser plays VP9 */
  DTS.pickSrc = function (v) {
    var w = v.dataset.srcWebm;
    if (w && v.canPlayType && v.canPlayType('video/webm; codecs="vp9, opus"')) return w;
    return v.dataset.src;
  };
  function videos() {
    if (!('IntersectionObserver' in window)) { DTS.lazyVideo = function (v) { if (v.dataset.src) { v.src = DTS.pickSrc(v); v.controls = true; } }; [].forEach.call(main.querySelectorAll('video[data-dts-video]'), DTS.lazyVideo); return; }
    // src only, no .load(): with preload="none" the browser then fetches nothing until play() (an explicit load() would pull the whole file for a clip that never plays)
    var near = new IntersectionObserver(function (es) { es.forEach(function (en) { var v = en.target; if (en.isIntersecting && !v.src && v.dataset.src) { v.src = DTS.pickSrc(v); near.unobserve(v); } }); }, { rootMargin: '60% 0px' });
    var play = new IntersectionObserver(function (es) {
      es.forEach(function (en) { var v = en.target; if (v.dataset.dtsManual === '1') return;
        if (en.isIntersecting && en.intersectionRatio >= 0.35) { if (!DTS.reduce && v.src) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); } } else if (!v.paused) v.pause(); });
    }, { threshold: [0, 0.35, 0.7] });
    DTS.lazyVideo = function (v) { if (v.__dts) return; v.__dts = true; v.muted = true; v.playsInline = true; near.observe(v); play.observe(v); };
    [].forEach.call(main.querySelectorAll('video[data-dts-video]'), DTS.lazyVideo);
  }

  /* ---------- smooth in-page anchors (native, no scroll hijack) ---------- */
  function anchors() {
    main.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]'); if (!a) return;
      var id = a.getAttribute('href').slice(1), el = id && document.getElementById(id); if (!el) return;
      e.preventDefault(); el.scrollIntoView({ behavior: DTS.reduce ? 'auto' : 'smooth', block: 'start' });
      var t = a.getAttribute('data-dts-track'); if (t) DTS.track('click', { id: t });
    });
    main.addEventListener('click', function (e) { var a = e.target.closest && e.target.closest('[data-dts-track]'); if (a && !(a.getAttribute('href') || '').startsWith('#')) DTS.track('click', { id: a.getAttribute('data-dts-track') }); });
  }

  /* GSAP + ScrollTrigger only where something uses them: wide screens without reduced motion (every module keeps a no-GSAP path). Phones skip ~46KB gz and two script executions. */
  function loadGsap(done) {
    var stage = main.querySelector('[data-dts-stage]'), urls = stage ? [stage.getAttribute('data-gsap'), stage.getAttribute('data-scrolltrigger')] : [];
    if (window.gsap && window.ScrollTrigger) return done();
    if (DTS.reduce || !window.matchMedia('(min-width: 990px)').matches || !urls[0] || !urls[1]) return done();
    var left = 2, fired = false;
    function one() { if (--left <= 0 && !fired) { fired = true; done(); } }
    urls.forEach(function (u) { var s = document.createElement('script'); s.src = u; s.async = false; s.onload = one; s.onerror = function () { if (!fired) { fired = true; done(); } }; document.head.appendChild(s); });
  }
  function boot() {
    reveals(); sky(); stars(); router(); anchors(); tips(); videos(); scan();
    loadGsap(function () {
      if (window.gsap && window.ScrollTrigger) { gsap.registerPlugin(ScrollTrigger); window.addEventListener('load', function () { ScrollTrigger.refresh(); }); if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { ScrollTrigger.refresh(); }); if (document.readyState === 'complete') ScrollTrigger.refresh(); }
      magnets();
      DTS.booted = true;
      DTS.modules.forEach(run);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
